import { api } from './client';
import type { ExtractResponse, ReviewStatus, StagedTask } from '../types/transcripts';

export interface ScanResult {
  processed: Array<{ fileId: string; fileName: string; folder: string; stagedCount: number }>;
  skipped:   Array<{ fileId: string; fileName: string; folder: string }>;
  failed:    Array<{ fileId: string; fileName: string; folder: string; error: string }>;
}

export function scanTranscripts(): Promise<ScanResult> {
  return api.post<ScanResult>('/api/transcripts/scan');
}

export function extractTranscript(transcript: string): Promise<ExtractResponse> {
  return api.post<ExtractResponse>('/api/transcripts/extract', { transcript });
}

export function fetchStagedTasks(reviewStatus: ReviewStatus | 'all' = 'PENDING'): Promise<StagedTask[]> {
  return api.get<StagedTask[]>(`/api/staged-tasks?review_status=${reviewStatus}`);
}

export function updateStagedTask(
  id: string,
  data: Partial<{
    title: string;
    description: string | null;
    theme_id: string | null;
    theme_name: string | null;
    sub_theme_name: string | null;
    assignee_ids: string[];
    status: string;
    priority: string;
    due_date: string | null;
  }>,
): Promise<StagedTask> {
  return api.patch<StagedTask>(`/api/staged-tasks/${id}`, data);
}

export function acceptStagedTask(id: string): Promise<{ task_id: string; staged_task_id: string }> {
  return api.post<{ task_id: string; staged_task_id: string }>(`/api/staged-tasks/${id}/accept`);
}

export function rejectStagedTask(id: string): Promise<{ ok: boolean }> {
  return api.post<{ ok: boolean }>(`/api/staged-tasks/${id}/reject`);
}

export interface BulkAcceptResult {
  accepted: Array<{ staged_task_id: string; task_id: string }>;
  failed:   Array<{ id: string; error: string }>;
}

export interface BulkRejectResult {
  rejected_ids: string[];
}

export function bulkAcceptStagedTasks(ids: string[]): Promise<BulkAcceptResult> {
  return api.post<BulkAcceptResult>('/api/staged-tasks/bulk-accept', { ids });
}

export function bulkRejectStagedTasks(ids: string[]): Promise<BulkRejectResult> {
  return api.post<BulkRejectResult>('/api/staged-tasks/bulk-reject', { ids });
}

export interface NotifyFoundersResult {
  sent: number;
  skipped: number;
  details: Array<{ name: string; emailed: boolean; reason?: string }>;
}

export function notifyFounders(): Promise<NotifyFoundersResult> {
  return api.post<NotifyFoundersResult>('/api/notify-founders', {});
}
